/**
 * Onboarding Carousel Type Definitions
 *
 * Shared types for the onboarding splash screen components.
 * Enables type-safe, consistent implementation across all slides.
 */

export interface OnboardingSlideProps {
  /** Callback to navigate to next slide */
  onNext: () => void;
  /** Callback to skip onboarding and go to login */
  onSkip: () => void;
  /** Whether the slide is currently active/visible */
  isActive: boolean;
  /** Direction of transition for animation */
  direction: 'left' | 'right' | null;
}

export interface WinSlideProps extends OnboardingSlideProps {
  /** Callback to trigger login/signup */
  onLogin: () => void;
  /** Whether auth is currently loading */
  isLoading: boolean;
}

export interface PaginationDotsProps {
  /** Total number of dots */
  total: number;
  /** Index of the active dot (0-based) */
  activeIndex: number;
  /** Position of the dots on screen */
  position?: 'top' | 'bottom';
}

export interface OnboardingCarouselProps {
  /** Callback to trigger login/signup */
  onLogin: () => void;
  /** Callback when user skips onboarding */
  onSkip: () => void;
  /** Whether auth is currently loading */
  isLoading: boolean;
}

/** Background images for each slide */
export const SLIDE_BACKGROUNDS = {
  commit: 'https://lh3.googleusercontent.com/aida-public/AB6AXuB3bXvA-D82KAM5pon3-KOzQ4S2xe4ynR5yXUPI2xe8CkNnNuLUkvGzdcbBMvLbsAEKoEEJCMqSX97e1RYyCfGMAmbp41Qq_rdSlAcycc62DH8ULeHraCW3L1gA2LW8adThJ9dehsOqQTTa1gzlU2BB31_1HcYVAsoq53iODpdnoQK1QXfuksvar1lupb5XtD2hFDRebnSokYNxHyr2vyA2pKgxMHnINJAfZE1hPeCatbuBrwo3DW1uuFC_I-mVyzaeLCtNrRShKp8a',
  track: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDO6s7B-4oo6JPomh3ro8ypBOWfRZtydtYKJAyrSdZKXhEs99w_Glzn0q8uJvvQ-YtXWe2ab2M61ydyExexu3TaxGHRDr0_13Wh9bOvT_Ynkdyd_Bg0l40eg7tPkGt472y4TFWdPrC-BSF-Ng8vdJfEOcRwbAr-Wl-mVYcR4YEQmQ8VV8wIgpIXCStGYNE6UV304M-8x1gyxRdjFFaKbTIBF1YpuIQJ81lNLTxj5HgSNf4mk_AsSjdHvZlzDzx1yo7SSc_WfY0YujZe',
  win: 'https://lh3.googleusercontent.com/aida-public/AB6AXuApyW4LqCdN3NQr_DSidL5EAcGD5sxV4rl149akCg3rrvltBwal1yQFXp_xlRoWf_ZKrA5aT7YhnCay-wORkmRNWajt9RGDmBb6BzGrF1GL2QtCIAm_9dZ02vEH4AdfN4qmdbGns-gS0doP3zEfcgGSCJPrRxhIYS3z-5GTyW4UggQ6WPjrY7TGmH2FDuPkAoXkQyRrsqAbLQdeeR-ZFpr4B2yBA_1NHAUlgTxxwWhKODnYdGO2G7FicCpgc4Tpl6vl5ejBaa64p7_4',
} as const;
